// One money formatter for the whole SPA: every USD amount renders with
// exactly two decimals ($4.90, $5.00, $1,234.50). Accepts numbers or
// numeric strings; anything that is not a finite number renders $0.00.

const USD = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const AMOUNT = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const toNumber = (value) => {
  if (value === null || value === undefined || value === '') return 0;
  const n = typeof value === 'number' ? value : Number(String(value).replace(/[$,\s]/g, ''));
  return Number.isFinite(n) ? n : 0;
};

/** "$1,234.50" — with the dollar sign (negative values render "-$4.90"). */
export const fmtUsd = (value) => USD.format(toNumber(value));

/** "1,234.50" — the same amount without the dollar sign, for copy that places "$" itself. */
export const fmtUsdAmount = (value) => AMOUNT.format(toNumber(value));
